import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from 'styles/colors';

import { useTheme } from '@mui/material';
import RoundButtonWithIcon from 'components/buttons/RoundButtonWithIcon';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { getBrandUISettings } from 'lib/utilities/Brands';
import { useContext } from 'react';
import sizes from 'styles/sizes';

const Button = styled(RoundButtonWithIcon)`
	width: 34px;
	height: 34px;
	background-color: ${colors.primary.ice};
	svg {
		width: 18px;
		height: 18px;
		path {
			fill: transparent;
			stroke: ${({ palette }) => palette.primary.dark};
		}
	}

	@media (min-width: ${sizes.media.tabletLandscape}px) {
		&.fill {
			&:hover,
			&.selected {
				background-color: ${({
					palette,
					hoverColors: {
						onHover: { color, tone },
					},
				}) => palette[`${color}`][`${tone}`]};
				color: ${colors.primary.ice};
				svg {
					path {
						fill: transparent;
						stroke: #fff;
					}
				}
			}
		}
	}
`;

/**
 * Calls RoundButtonWithIcon, displaying the 'favorite' icon.
 * Currently used by BarButtons and SearchCard.
 *
 * @param {func} onClick
 * @param {string} className
 */

const RoundShareButton = ({ onClick, className }) => {
	const { brand } = useContext(CruiseSearchContext);
	const { palette } = useTheme();
	const { uiSettings } = getBrandUISettings(brand);
	const { hover } = uiSettings.common.buttons;

	return <Button className={className} palette={palette} hoverColors={hover} onClick={onClick} icon="share" colorFill />;
};

RoundShareButton.propTypes = {
	onClick: PropTypes.func,
	className: PropTypes.string,
};

export default RoundShareButton;
